module.exports = __webpack_public_path__ + "img/car.e04a894a.jpeg";